(ns frontend.view.user-management.teams
    (:require
      [common.localization :as loc]
      [common.modules :as modules]
      [frontend.actions.entity :as entity-actions]
      [frontend.state.current-session :as session]
      [frontend.view.error-utils :as error-utils]
      [frontend.view.user-management.components :as components]
      [frontend.view.user-management.events :as events]
      [oops.core :as oops]
      [reagent.core :as r]
      [ui.components.grid.view :as grid]))

(defn toggle-module
  [{:keys [column-meta entity-id on?]}]
  (let [module-key column-meta
        team-id entity-id
        team (get @session/entities team-id)
        team-modules (if on?
                       (conj (:team/modules team) module-key)
                       (disj (:team/modules team) module-key))]
    (entity-actions/*->entity-update! team-id
                                      {:team/modules team-modules}
                                      (fn [& _args])
                                      (partial error-utils/show-error! loc/tr))))

(defn toggle-export-access
  [{:keys [entity-id on?]}]
  (let [team-id entity-id]
    (entity-actions/*->entity-update! team-id
                                      {:team/deny-export-access (boolean on?)}
                                      (fn [& _args])
                                      (partial error-utils/show-error! loc/tr))))

(defn toggle-read-only-access!
  [{:keys [row-data on?]}]
  (let [team-id (:id row-data)]
    (entity-actions/*->entity-update! team-id
                                      {:team/read-only-team? (boolean on?)}
                                      (fn [& _args]
                                        (js/console.log "Successfully changed read only access"))
                                      (partial error-utils/show-error! loc/tr))))

(defn toggle-activity-access
  [{:keys [column-meta entity-id on?]}]
  (let [activity-type column-meta
        team-id entity-id
        team (get @session/entities team-id)
        accessible-activities (if on?
                                (conj (set (:team/accessible-activities team)) activity-type)
                                (disj (set (:team/accessible-activities team)) activity-type))]
    (entity-actions/*->entity-update! team-id
                                      {:team/accessible-activities accessible-activities}
                                      (fn [& _args])
                                      (partial error-utils/show-error! loc/tr))))

(def team-activity-access-types
  [:entity.type/task
   :entity.type/note
   :entity.type/note-call
   :entity.type/note-meeting
   :entity.type/note-message
   :entity.type/email
   :entity.type/system-activity])

(defn resolve-columns
  [state]
  (let [all-modules (modules/all-modules @session/tenant
                                         @session/tenant-plan)]

    (concat
      [{:children [{:headerName       (loc/tr :team/name)
                    :sortable         true
                    :field            :team/name
                    :autoHeaderHeight true
                    :pinned           "left"
                    :checkboxSelection true
                    :headerCheckboxSelection false}
                   {:column/key   :team/deny-export-access
                    :headerName   (loc/tr :team-export-access)
                    :cellClass    "flex items-center"
                    :field        :team/deny-export-access
                    :cellRenderer (fn [props]
                                    (let [data (js->clj (aget props "data") {:keywordize-keys true})
                                          entity-id (:id data)]
                                      (r/as-element
                                        (components/toggle-cell-renderer toggle-export-access
                                                                         {:cell-value (events/get-cell-value props)
                                                                          :state      state
                                                                          :entity-id  entity-id
                                                                          :row-data   data}))))}]}]
      (when (session/has-feature-access? :feature/read-only-teams)
        [{:children [{:column/key   :team/read-only-team?
                      :cellClass    "flex items-center"
                      :headerName   (loc/tr :team-read-only-access)
                      :field        :team/read-only-team?
                      :cellRenderer (fn [props]
                                      (let [data (js->clj (aget props "data") {:keywordize-keys true})]
                                        (r/as-element
                                          (components/toggle-team-read-only-renderer
                                            toggle-read-only-access!
                                            {:cell-value (events/get-cell-value props)
                                             :state      state
                                             :row-data   data}))))}]}])
      [{:headerName (loc/tr :settings/modules-heading)
        :children   (->> all-modules
                         (sort-by loc/tr)
                         (map (fn [module]
                                {:column/key   module
                                 :headerName   (loc/tr module)
                                 :cellClass    "flex items-center"
                                 :field        module
                                 :cellRenderer (fn [props]
                                                 (let [data (js->clj (aget props "data") {:keywordize-keys true})
                                                       entity-id (:id data)]
                                                   (r/as-element
                                                     (components/toggle-cell-renderer toggle-module
                                                                                      {:state       state
                                                                                       :cell-value  (events/get-cell-value props)
                                                                                       :entity-id   entity-id
                                                                                       :column-meta module}))))}))
                         (into []))}]
      [{:headerName (loc/tr :activity-access)
        :children   (->> team-activity-access-types
                         (map (fn [activity-type]
                                (let [header-name (case activity-type
                                                    :entity.type/task (loc/tr :activity-view/tab-tasks)
                                                    :entity.type/note (loc/tr :activity-view/tab-notes)
                                                    :entity.type/note-call (loc/tr :activity-view/tab-calls)
                                                    :entity.type/note-meeting (loc/tr :activity-view/tab-meetings)
                                                    :entity.type/note-message (loc/tr :activity-view/tab-messages)
                                                    :entity.type/email (loc/tr :activity-view/tab-emails)
                                                    :entity.type/system-activity (loc/tr :activity-label-system-logs)
                                                    (name activity-type))]
                                  {:column/key   activity-type
                                   :headerName   header-name
                                   :cellClass    "flex items-center"
                                   :field        activity-type
                                   :cellRenderer (fn [props]
                                                   (let [data (js->clj (aget props "data") {:keywordize-keys true})
                                                         entity-id (:id data)]
                                                     (r/as-element
                                                       (components/toggle-cell-renderer toggle-activity-access
                                                                                        {:state       state
                                                                                         :cell-value  (events/get-cell-value props)
                                                                                         :entity-id   entity-id
                                                                                         :column-meta activity-type}))))})))
                         (into []))}])))
(defn resolve-row-data
  [team]
  (let [modules (modules/all-modules @session/tenant @session/tenant-plan)]
    (merge team
           {:trunc-limit               15
            :team.settings/has-admins? (->> team
                                            :team/members
                                            (keep session/get-entity)
                                            (some session/admin-account?))}
           (->> modules
                (map (fn [module]
                       [module (boolean (some #{module} (:team/modules team)))]))
                (into {}))
           (->> team-activity-access-types
                (map (fn [activity-type]
                       [activity-type (boolean (some #{activity-type} (:team/accessible-activities team)))]))
                (into {})))))

(defn view
  [state]
  (let [update-search-term! (fn [value]
                              (swap! state assoc :team-search value))
        column-defs (resolve-columns state)
        on-selection-changed (fn [params]
                               (let [grid-api (aget params "api")
                                     selected-nodes-js (oops/ocall grid-api "getSelectedNodes")
                                     selected-nodes (js->clj selected-nodes-js :keywordize-keys true)
                                     selected-node (first selected-nodes)]
                                 (if selected-node
                                   (let [selected-node-data (aget selected-node "data")
                                         selected-node-id (:id (js->clj selected-node-data {:keywordize-keys true}))]
                                     (swap! state assoc :selected-team-id selected-node-id))
                                   (swap! state dissoc :selected-team-id))))
        grid-top-offset* (r/atom 316)                       ;; about the default top offset
        local-state (r/atom {})]
    (swap! state assoc :selected-tab :settings/teams)
    (fn [state]
      (let [teams @session/teams
            resolved-teams (->> teams
                                (events/filter-teams-by-search state (:team-search @state))
                                (map resolve-row-data)
                                (seq))]
        [:div
         {:class "p-4 flex flex-col gap-4"}
         [:div
          {:class "flex items-start gap-2 text-base-light-text-paler"}
          [:i
           {:class "pt-1 fas fa-info-circle"}]
          [:span (loc/tr :settings/teams-notification)]]
         [:div
          {:class "flex items-center gap-4"}
          [:div
           {:class "min-w-72 relative"}
           [components/search-bar (:team-search @state) update-search-term! state]
           [:i
            {:class "fal fa-search absolute top-2/4 -translate-y-2/4 right-3"}]]]
         (if-not resolved-teams
           [components/not-found-view]
           [:div
            {:style {"--teams-grid-top-offset" (str @grid-top-offset* "px")}}
            [:div
             {:class "py-2 flex gap-3 text-base-light-text"}
             [components/team-tools
              {:external-state state
               :local-state    local-state}]]
            [grid/top-offset-sentinel
             {:set-top-offset (fn [offset]
                                (reset! grid-top-offset* offset))}]
            [:div
             {:class "h-[max(200px,calc(100vh-var(--teams-grid-top-offset)-16px-1px))]"}
             [grid/ag-grid-enterprise
              {:theme                grid/theme-quartz
               :onGridReady          (fn [event]
                                       (swap! local-state assoc-in [:grid :ref] event))
               :column-defs          column-defs
               :row-data             resolved-teams
               :getRowId             (fn [params]
                                       (-> params
                                           (oops/oget "data")
                                           (oops/oget "id")))
               :getRowClass          (fn [js-params]
                                       (let [row-index (oops/oget js-params "rowIndex")
                                             last? (= row-index (dec (count resolved-teams)))]
                                         (when last?
                                           "border-b-[var(--ag-border-color)]")))
               :default-col-def      {:sortable true
                                      :editable false
                                      :menuTabs ["generalMenuTab"]}
               :width                "100%"
               :row-selection        {:mode "singleRow"
                                      :checkboxes false}
               :on-selection-changed on-selection-changed}]]])]))))
